import { render, staticRenderFns } from "./brandSidebar.vue?vue&type=template&id=39e664e8&scoped=true&"
import script from "./brandSidebar.vue?vue&type=script&lang=js&"
export * from "./brandSidebar.vue?vue&type=script&lang=js&"
import style0 from "./brandSidebar.vue?vue&type=style&index=0&id=39e664e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e664e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e664e8')) {
      api.createRecord('39e664e8', component.options)
    } else {
      api.reload('39e664e8', component.options)
    }
    module.hot.accept("./brandSidebar.vue?vue&type=template&id=39e664e8&scoped=true&", function () {
      api.rerender('39e664e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/shop/sidebar/brandSidebar.vue"
export default component.exports